<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="closeDialog"
    width="850"
    scrollable
  >
    <v-card class="elevation-3">
      <v-card-title class="primary text-h5 white--text">
        Tracker Permissions
      </v-card-title>
      <v-card-text class="pa-5">
        <TrackedBillAgencyGrid
          :trackedBillAgencies="trackedBillAgencies"
          :currentUserPermissionID="currentUserPermissionID"
          :trackedBillID="trackedBillID"
          @refreshAgencyPermissions="refreshAgencyPermissions"
        >
        </TrackedBillAgencyGrid>
        <TrackedBillUserGrid
          :trackedBillUsers="trackedBillUsers"
          :currentUserPermissionID="currentUserPermissionID"
          :trackedBillID="trackedBillID"
          @refreshUserPermissions="refreshUserPermissions"
        ></TrackedBillUserGrid>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined color="primary" @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBillAgencyGrid from '@components/form/grid/TrackedBillAgencyGrid'
import TrackedBillUserGrid from '@components/form/grid/TrackedBillUserGrid'
export default {
  //model: {
  //	prop: ''
  //},
  props: {
    trackedBillID: {
      type: Number,
      required: true,
    },
    currentUserPermissionID: {
      type: Number,
      required: true,
    },
  },
  components: { TrackedBillAgencyGrid, TrackedBillUserGrid },
  filters: {},
  data() {
    return { dialog: false, trackedBillAgencies: [], trackedBillUsers: [] }
  },
  created() {},
  computed: {},
  methods: {
    ...call('trackedBillUser', ['loadTrackedBillUsersForBill']),
    ...call('trackedBillAgency', ['loadTrackedBillAgenciesForBill']),

    openPermissions(bill) {
      this.trackedBillAgencies = bill.TrackedBillAgencies
      this.trackedBillUsers = bill.TrackedBillUsers
      this.dialog = true
    },
    refreshAgencyPermissions() {
      this.loadTrackedBillAgenciesForBill(this.trackedBillID).then((res) => {
        this.trackedBillAgencies = res.data
      })
    },
    refreshUserPermissions() {
      this.loadTrackedBillUsersForBill(this.trackedBillID).then((res) => {
        this.trackedBillUsers = res.data
      })
    },
    closeDialog() {
      this.$emit('refreshBill')
      this.dialog = false
    },
  },
  watch: {},
}
</script>
<style scoped></style>
